import { initializeDesertState, updateDesertState } from './desertState.js';
import { drawDesertBackground, drawSandDunes } from './desertBackground.js';
import { drawAudioBars } from './audioBars.js';
import { drawRockFormations } from './rockFormations.js';
import { updateSandwormState, drawMassiveSandworm } from './sandworm.js';
import { updateScavengerState, drawScavenger } from './scavenger.js';
import { drawFloatingSand, drawHeatShimmer } from './atmosphericEffects.js';

export function drawDesertEnvironment(ctx, dataArray, width, height, time) {
  if (!ctx || !dataArray || width <= 0 || height <= 0) return;
  
  // Initialize desert state if needed
  initializeDesertState(dataArray, width, height);
  
  const deltaTime = updateDesertState(time);
  
  // Draw desert background
  drawDesertBackground(ctx, width, height, time);
  
  // Draw sand dunes in background
  drawSandDunes(ctx, width, height, time);
  
  // Draw audio-reactive bars
  drawAudioBars(ctx, dataArray, width, height, time, deltaTime);
  
  // Draw desert elements
  drawRockFormations(ctx, time);
  
  // Update and draw sandworm
  updateSandwormState(deltaTime, width, height);
  drawMassiveSandworm(ctx, width, height, time);
  
  // Update and draw scavenger
  updateScavengerState(deltaTime, width, height);
  drawScavenger(ctx, time);
  
  // Draw atmospheric effects
  drawFloatingSand(ctx, width, height, time);
  drawHeatShimmer(ctx, width, height, time);
}